var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('single-image',{attrs:{"schema":_vm.schema,"mediaURL":_vm.mediaURL,"queryString":_vm.queryString},on:{"error":_vm.handleError}})}
var staticRenderFns = []

export { render, staticRenderFns }